import { render, staticRenderFns } from "./VisionFieldForm.vue?vue&type=template&id=3a984f06&scoped=true&lang=pug&"
import script from "./VisionFieldForm.vue?vue&type=script&lang=js&"
export * from "./VisionFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./VisionFieldForm.vue?vue&type=style&index=0&id=3a984f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a984f06",
  null
  
)

export default component.exports